import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ApiClient from '../../methods/api/apiClient';
import { toast } from 'react-toastify';
import Layout from "../../components/global/layout";
import FormControl from "../../components/common/FormControl";
import { Tooltip } from 'antd';

const EditFAQ = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [form, setForm] = useState({
    question: '',
    answer: '',
    status: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (id) {
      fetchFAQDetail(); // Fetch details only if editing
    }
  }, [id]);

  const fetchFAQDetail = async () => {
    setLoading(true);
    try {
      const response = await ApiClient.get('faq/detail', { id });
      if (response.success) {
        setForm(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('Failed to fetch FAQ details');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const { question, answer } = form;
    if (!question || !answer) {
      return;
    }
    setLoading(true);

    try {
      let response;

      if (id) {
        // Edit FAQ
        response = await ApiClient.put('faq/update', { id, ...form });
      } else {
        // Add new FAQ
        response = await ApiClient.post('faq/add',{ question,
          answer});
      }

      if (response.success) {
        toast.success(id ? 'FAQ updated successfully' : 'FAQ added successfully');
        navigate('/faq');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('Failed to save FAQ');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <Layout>
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="pprofile1">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => navigate(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                {id ? 'Edit FAQ' : 'Add FAQ'}
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="mb-3">
              <FormControl
                type="text"
                name="question"
                label="Question"
                placeholder="Enter the question"
                value={form.question}
                onChange={(e) => setForm((prev) => ({ ...prev, question: e }))}
                required
              />
              {submitted && !form.question && <div className="text-red-600">Question is required</div>}
            </div>
          </div>

          <div className="mb-3">
            <label>Answer <span className="text-red-600"> *</span></label>
            <textarea
              name="answer"
              className="w-full border rounded-lg p-2"
              placeholder="Enter the answer"
              value={form.answer}
              onChange={handleChange}
              rows={6}
              required
            />
            {submitted && !form.answer && <div className="text-red-600">Answer is required</div>}
          </div>

          <div className="text-right">
            <button
              type="submit"
              className="text-white bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              disabled={loading}
            >
              {loading ? 'Saving...' : id ? 'Update FAQ' : 'Add FAQ'}
            </button>
          </div>
        </div>
      </form>
    </Layout>
  );
};

export default EditFAQ;
